import { Column, RowColumnProps } from 'components/Blocks/Containers';
import { FieldError } from './FieldError';

interface FieldErrorWrapperProps extends RowColumnProps {
  error?: unknown;
  errorClassName?: string;
}

export function FieldErrorWrapper({
  error,
  errorClassName,
  gap = '1',
  children,
  ...rest
}: FieldErrorWrapperProps) {
  return (
    <Column gap={gap} {...rest}>
      {children}

      <FieldError error={error} className={errorClassName} />
    </Column>
  );
}
